<template>
  <div class="column q-pa-md">
    <div class="row justify-between items-center">
      <h6 class="text-h6 text-grey-8 q-ma-none">
        Adicionar filtros
      </h6>
      <q-btn
        icon="close"
        flat
        @click="$emit('close')"
      />
    </div>

    <div
      v-if="loading"
      class="row justify-center items-center q-mt-xl"
    >
      <q-spinner
        color="primary"
        size="2rem"
        :trickness="4"
      />
    </div>
    <div
      v-else
      class="column q-mb-xl"
    >
      <div
        v-for="(option,index) in options"
        :key="option.name"
        class="column q-mt-lg"
      >
        <p class="text-body2 text-grey-6 q-mb-sm">
          {{ option.name }}
        </p>

        <div v-if="!option.catalog_id">
          <q-select
            :value="selected(option.key)"
            filled
            use-input
            use-chips
            multiple
            option-label="name"
            option-value="value"
            input-debounce="600"
            label="Selecione"
            :options="hashOptions[option.key]"
            class="col-12"
            @filter="(val, update, abort) => filterFn(option.key, val, index, update, abort, option.options)"
            @add="(v) => select(option.key, v.value)"
            @remove="(v) => unselect(option.key, v.value[0].value)"
          >
            <template
              v-if="selected(option.key).length > 0"
              v-slot:append
            >
              <q-icon
                name="cancel"
                class="cursor-pointer"
                @click.stop="clearSelected(option.key)"
              />
            </template>
            <template v-slot:selected-item="scope">
              <q-chip
                removable
                dense
                :tabindex="scope.tabindex"
                class="q-ma-none"
                @remove="scope.removeAtIndex(scope.index)"
              >
                {{ scope.opt.name || scope.opt.value }}
              </q-chip>
            </template>
          </q-select>
        </div>
        <div v-if="option.catalog_id">
          <catalog-picker-mult
            :value="selectedCatalog(option.key)"
            :root="option.catalog_id"
            @input="(v) => onCatalogChange(option.key, v)"
          />
        </div>
      </div>
    </div>

    <div class="fixed-bottom q-ma-md">
      <q-btn
        icon="add"
        :disable="loading"
        class="full-width"
        label="Adicionar"
        color="primary"
        @click.native="applyFilters"
      />
    </div>
  </div>
</template>

<script>
import CatalogPickerMult from '../CatalogPickerMult';

const CURRENTY_YEAR = new Date().getFullYear();
const SLICE_YEAR = 1950;
const YEAR_OPTIONS = [...Array(CURRENTY_YEAR + 2).keys()]
  .slice(SLICE_YEAR).map(value => ({ name: value, value })).reverse();

const SCHOLARITY_OPTIONS = [
  { value: 'Nível fundamental', name: 'Nível fundamental' },
  { value: 'Nível médio', name: 'Nível médio' },
  { value: 'Nível superior', name: 'Nível superior' },
];

const TYPE_OPTIONS = [
  { value: 'MULTIPLE_CHOICE', name: 'Múltipla escolha' },
  { value: 'TRUE_OR_FALSE', name: 'Certo/Errado' },
  { value: 'DISCURSIVE', name: 'Discursiva' },
  { value: 'PIECE', name: 'Peça' },
  { value: 'FLASHCARD', name: 'Flashcard' },
];

export default {
  name: 'New',
  components: {
    CatalogPickerMult,
  },
  props: {
    initialFilters: { type: Array, required: false, default: () => [] },
    whereIs: { type: String, required: true },
    onFilterChange: { type: Function, required: true },
  },
  data: () => ({
    loading: false,
    filters: [],
    config: null,
    hashOptions: {},
    userGroups: {
      status_owner: [],
      author_email: [],
    },
  }),
  computed: {
    catalogFields() {
      if (!this.config) {
        return [];
      }

      const fields = [];
      for (const c of this.config.catalogs) {
        fields.push({
          name: c.name,
          key: c.key,
          catalog_id: c.id,
        });
      }

      return fields;
    },
    options() {
      const vertical = sessionStorage.getItem('vertical') || 'concursos';

      const options = [];

      if (this.whereIs === 'question') {
        options.push(
          {
            name: 'Matéria',
            key: 'topic',
            options: [],
          },
          {
            name: 'Autor',
            key: 'author_email',
            options: [],
          },
          {
            name: 'Responsável',
            key: 'status_owner',
            options: [],
          },
          {
            name: 'Tipo de Questão',
            key: 'answer_type',
            options: TYPE_OPTIONS,
          },
        );

        if (vertical === 'concursos') {
          options.push({
            name: 'Escolaridade',
            key: 'scholarity',
            options: SCHOLARITY_OPTIONS,
          });
        }
      }

      options.push({
        name: 'Ano',
        key: 'year',
        options: YEAR_OPTIONS,
      });

      options.push(...this.catalogFields);

      return options;
    },
  },
  watch: {
    whereIs: {
      immediate: true,
      async handler(val, oldVal) {
        if (val !== oldVal) {
          this.filters = [];
        }
      },
    },
    initialFilters: {
      immediate: true,
      async handler(val) {
        this.filters = val;
      },
    },
  },
  async mounted() {
    this.config = await this.$services.config.get();

    const groupAdminId = this.$services.accounts.getGroupAdminId();
    const groupTeacherId = this.$services.accounts.getGroupTeacherId();
    const groupOperatorId = this.$services.accounts.getGroupOperatorId();

    this.userGroups.author_email = [groupAdminId, groupOperatorId];
    this.userGroups.status_owner = [groupAdminId, groupTeacherId];
  },
  methods: {
    filterFn(key, val, optionsIndex, update, _, options) {
      update(async () => {
        if (key === 'topic') {
          const resp = await this.$services.topicsrest.search({
            page: 0,
            perPage: 50,
            query: val,
          });

          this.hashOptions[key] = resp.topics.map(this.mountTopicsFormated);
        }

        if (['author_email', 'status_owner'].includes(key)) {
          const resp = await this.$services.accounts.searchUsersByGroups({
            term: val,
            groups: this.userGroups[key],
            page: 0,
            perPage: 50,
          });

          this.hashOptions[key] = resp.map(this.mountUserFormated);
        }

        if (!this.hashOptions[key]) {
          this.hashOptions[key] = options;
        }

        if (['year', 'scholarity'].includes(key)) {
          this.hashOptions[key] = options.filter(option => {
            let v = option;

            if (typeof option === 'object') {
              v = option.name;
            }

            return String(v).toLowerCase().startsWith(val.toLowerCase());
          });
        }

        this.$forceUpdate();
      });
    },
    filterName(key) {
      return this.options.find((v) => v.key === key).name;
    },
    selected(key) {
      return this.filters.filter((v) => v.key === key);
    },
    selectedCatalog(key) {
      return this.filters.filter((v) => v.key === key).map((v) => v.value);
    },
    select(key, value) {
      this.filters = [...this.filters, { key, value: value.value, name: value.name }];
    },
    unselect(key, value) {
      const idx = this.filters.findIndex((v) => v.key === key && String(v.value) === String(value));
      this.filters = [...this.filters.slice(0, idx), ...this.filters.slice(idx + 1, this.filters.length)];
    },
    clearSelected(key) {
      this.filters = this.filters.filter((v) => v.key !== key);
    },
    onCatalogChange(key, value) {
      this.filters = [
        ...this.filters.filter((v) => v.key !== key),
        ...value.map((v) => ({ key, value: v, isCatalog: true })),
      ];
    },
    applyFilters() {
      this.onFilterChange(this.filters.map((f) => ({
        ...f,
        type: this.filterName(f.key),
        name: f.name,
      })));
      this.$emit('ok');
    },
    mountTopicsFormated(catalog) {
      return {
        name: catalog.name,
        value: catalog.id,
      };
    },
    mountUserFormated(user) {
      return {
        name: user.email,
        value: user.email,
      };
    },
  },
};
</script>
